(function() {
  function initializeProductHover() {
    handleViewportChange();
    window.addEventListener('resize', handleViewportChange);

    function handleViewportChange() {
      if (window.innerWidth > 768) {
        attachHoverEventListeners();
      } else {
        attachSwipeEventListeners();
      }
    }

    function attachHoverEventListeners() {
      const productContainers = document.querySelectorAll('.collection-product-container');
      productContainers.forEach(container => {
        container.addEventListener('mouseover', handleProductHover);
        container.addEventListener('mouseout', handleProductHoverOut);
      });
    } 

    function attachSwipeEventListeners() {
      const productContainers = document.querySelectorAll('.collection-product-container');
      productContainers.forEach(container => {
        let startX = null;
        let startY = null;

        container.addEventListener('touchstart', event => {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        });

        container.addEventListener('touchend', event => {
          const endX = event.changedTouches[0].clientX;
          const endY = event.changedTouches[0].clientY;
          const deltaX = endX - startX;
          const deltaY = Math.abs(endY - startY);

          if (deltaX > 50 && deltaY < 20) {
            showPreviousImage(container);
          } else if (deltaX < -50 && deltaY < 20) {
            showNextImage(container);
          }
        });
      });
    }

    function handleProductHover(event) {
      const productImages = event.currentTarget.querySelectorAll('img');
      
      if (productImages.length >= 2) {
        productImages[0].style.visibility = 'hidden';
        productImages[1].style.visibility = 'visible';
      }
    }

    function handleProductHoverOut(event) {
      const productImages = event.currentTarget.querySelectorAll('img');
      
      if (productImages.length >= 2) {
        productImages[0].style.visibility = 'visible';
        productImages[1].style.visibility = 'hidden';
      }
    }

    function showPreviousImage(container) {
      const productImages = container.querySelectorAll('img');
      
      if (productImages.length >= 2) {
        productImages[0].style.visibility = 'visible';
        productImages[1].style.opacity = '0';
        productImages[0].style.filter = 'blur(0px)';
        productImages[1].style.filter = 'blur(5px)';
      }
    }

    function showNextImage(container) {
      const productImages = container.querySelectorAll('img');
      
      if (productImages.length >= 2) {
        productImages[1].style.visibility = 'visible';
        productImages[0].style.opacity = '0';
        productImages[1].style.opacity = '1';
        productImages[0].style.filter = 'blur(5px)';
        productImages[1].style.filter = 'blur(0px)';
      }
    }
  }

  window.initializeProductHover = initializeProductHover;

  // Call the function on initial load
  document.addEventListener('DOMContentLoaded', initializeProductHover);
})();
